import { Listing } from '@reverbdotcom/commons/src/rql';
import React from 'react';
import { camelize } from 'humps';
import I18n from 'i18n-js';

const LIVE = 'live';
const SUSPENDED = 'suspended';
interface IExternalProps {
  listing: Listing;
}
interface IListingStateProps {
  listing: Listing;
}

export function ListingState({ listing }: IListingStateProps) {
  const isLive = listing.state === LIVE;
  const isSuspended = listing.state === SUSPENDED;

  let colorToken = 'rc-color-palette-gray-600';

  if (isLive) {
    colorToken = 'rc-color-palette-green-600';
  } else if (isSuspended) {
    colorToken = 'rc-color-text-danger';
  }

  return (
    <div className="weight-bold size-90" style={{ color: `var(--${colorToken})` }}>
      {I18n.t(`discovery.listingsManagement.sellerListingCard.states.${camelize(listing.state)}`).toUpperCase()}
    </div>
  );
}

export default function SellerListingCardFooter({ listing }: IExternalProps) {
  return (
    <div className="seller-listing-card-footer">
      <ListingState listing={listing} />
    </div>
  );
}
